// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"746":"e70327b9","798":"0c50475b"}[chunkId] + ".chunk.css";
};